import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HolidayBookingService} from '../../holiday-booking-page/services/holiday-booking.service';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {IHolidayDetailSolution} from '../../holiday-detail-page/interfaces/iholiday-detail-solution';
import {CmsService} from '../../../../cms/services/cms.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EngineGuestsModalComponent } from 'src/app/modules/search-engine/components/engine-guests-modal/engine-guests-modal.component';
import { BookingService } from 'src/app/modules/shared/services/booking.service';
import { Networks } from 'src/app/modules/shared/models/networks.enum';
import { PostMessageService } from 'src/app/modules/shared/services/post-message.service';
import { WidgetService } from 'src/app/modules/shared/services/widget.service';

@Component({
  selector: 'holiday-detail-generic-page-recap',
  templateUrl: './holiday-detail-generic-page-recap.component.html',
  styleUrls: ['./holiday-detail-generic-page-recap.component.scss']
})
export class HolidayDetailGenericPageRecapComponent implements OnInit, OnDestroy {
  @ViewChild('editGuestsRef') editGuestsRef: ElementRef;

  @Input() fallbackPrice: number;
  @Input() allAvailableDates: Date[];
  @Input() destinationName: string;
  @Input() allSolutionForSelectedDate: IHolidayDetailSolution[];
  @Input() formattedGuestsString: string;

  public isWidget$: Observable<boolean>;
  public selectedDepartureDate: Date;

  public location = encodeURIComponent(location.href);
  public isLoading: boolean;
  public bestPriceAmongAvailableSolutions: number;
  public validSolutionsFound: number;
  private unsubscribe$ = new Subject();
  public brand: any;
  public wtgNetworkId;

  constructor(
    private _holidayBookingService: HolidayBookingService,
    private _cmsService: CmsService,
    private _modalService: NgbModal,
    private _bookingService: BookingService,
    private _widgetService: WidgetService,
    private _postMessageService: PostMessageService,
  ) {
    this.wtgNetworkId = Networks.WTG;
  }

  ngOnInit(): void {
    this.isWidget$ = this._widgetService.isWidget();

    this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) {
        this.brand = brand;
      }
    });

    this._holidayBookingService.holidayDetailLoadingStatus$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((loadingStatus) => {
        this.isLoading = loadingStatus.isLoadingDetail || loadingStatus.isLoadingLivePrices || loadingStatus.isDebounceing;
        if (!this.isLoading && this.allSolutionForSelectedDate?.length) {
          setTimeout(() => {
            this.onLivePricesUpdated(this.allSolutionForSelectedDate);
          }, 50);
        }
      });

    this._holidayBookingService.selectedDepartureDate$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((departureDate: Date) => {
        this.selectedDepartureDate = departureDate;
      });

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public onClickOnChooseDate() {
    this._holidayBookingService.departureDateAccordionTrigger$.next(true);
  }

  public onClickOnChooseSolution() {
    document.querySelector('#solutionsList')?.scrollIntoView({
      behavior: 'smooth'
    });
  }

  //  Ad ogni aggiornamento completato dei livePrice, imposta numero di soluzioni trovate e miglior prezzo
  private onLivePricesUpdated(allSolutions: IHolidayDetailSolution[]): void {
    const allValidSolutions = allSolutions.filter((solution: IHolidayDetailSolution) => !solution.liveError && solution?.totalPrice > 0);
    this.validSolutionsFound = allValidSolutions?.length;
    this.bestPriceAmongAvailableSolutions = allValidSolutions.find((solution: IHolidayDetailSolution) => solution.isCheapest)?.totalPrice || null;
  }

  public openEngineGuestsModal(): void {
    setTimeout(() => {
      // effettuo uno scroll verso il link "Modifica passeggeri" in modo da visualizzare nella posizione corretta la modale
      if (this.isWidget$) {
        const targetElementPosition = document.querySelector('.holiday-guests')?.getBoundingClientRect();
        if (!targetElementPosition) {
          return;
        }
        const positionToScroll = targetElementPosition.top + window.pageYOffset;

        // effettuo lo scroll del parent
        this._postMessageService.scrollToElementPos(positionToScroll);
      } else {
        this.editGuestsRef?.nativeElement.scrollIntoView();
      }
    }, 250);
    const engineGuestsModalRef = this._modalService.open(
        EngineGuestsModalComponent,
        {
          ariaLabelledBy: 'modal-engine',
          size: 'lg'
        }
    );
    engineGuestsModalRef.componentInstance.isOpenIntoDetailPage = true;
    engineGuestsModalRef.componentInstance.selectedGuests.subscribe(
        (occupancy) => {
          // aggiorno il dettaglio holiday con l'occupancy appena modificato dalla modale
          // NB: viene eseguito prima un controllo se ci sono disponibilità per le età inserite e in caso, riesegue
          // la chiamata del dettaglio con le nuove età dei passeggeri
          this._bookingService.setNewAges(occupancy.ages);
        }
    );
  }
}
